module.exports = __webpack_public_path__ + "assets/images/pages/kfc/kfc-2.webp?c208a00a";